import React from "react";

// Material UI Components
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";

// Components
import LoginLogsHeader from "./LoginLogsHeader";
import LoginLogsBody from "./LoginLogsBody";

// This component will hold the latest leads data
const LoginLogsTable = ({ loginLogs, totalLogins, open }) => {
  return (
    <div className={`defaulted ${open ? "show-table" : "hide-table"}`}>
      <h4 className="aggregated-report-count">Total Logins {totalLogins}</h4>
      <TableContainer>
        <Table className="table" size={"small"}>
          <LoginLogsHeader />
          <LoginLogsBody loginLogs={loginLogs} />
        </Table>
      </TableContainer>
      <div className="bottom-footer"></div>
    </div>
  );
};

export default LoginLogsTable;
